import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function Keywords({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Keywords'} email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

